import Http from './Http'

export default {
    async getKeys(data) {
        return await Http.get(`/redis/keys?${data}`)
    },
    async getKeyDetails(key) {
        return await Http.get(`/redis/keys/details?key=${key}`)
    },
    async deleteKey(data) {
        return await Http.delete(`/redis/keys`, { params: data })
    },
}